<template>
  <div class="login-background-panel row">
    <div class="form-panel">
      <img src="@/assets/static/img/plyo-logo.svg">
      <form-content></form-content>
    </div>
  </div>
</template>
<script>
  import FormContent from './Content.vue'

  export default {
    components: {
      FormContent,
    },
  }
</script>